import { InjectionToken, inject } from '@angular/core';
import { AgentHubService } from './agent.hub.service';

export const AGENT_SIGNALR_HUB = new InjectionToken<AgentHubService>(
    'AGENT_SIGNALR_HUB',
    {
        providedIn: 'root',
        factory: () => inject(AgentHubService),
    },
);
